export default __webpack_public_path__ + "static/media/principal.bec33d30.jpg";